module.exports = __webpack_public_path__ + "img/female.d2547d40.png";